import { StateAdditionalTaxesTable } from "../StateAdditionalTaxesTable";
import { StateTaxDetailTable } from "../StateTaxDetailTable";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStateTaxTable extends Layout {
    buttonVersion: Button;
    checkAutoTaxTable: Switch;
    checkDeductFed: Checkbox;
    checkboxDeductFica: Checkbox;
    dataheaderStateLocalTaxTable: DataHeader;
    labelETT: Label;
    labelHeadOfHouseholdTable: Label;
    labelMarriedTaxTable: Label;
    labelSDI: Label;
    labelSUI: Label;
    labelSingleTaxTable: Label;
    layoutHeadOfHouseholdTaxTable: StateTaxDetailTable;
    layoutMarriedTaxTable: StateTaxDetailTable;
    layoutSingleTaxTable: StateTaxDetailTable;
    layoutStateAdditionalTaxesTable: StateAdditionalTaxesTable;
    panelAutoTableGeneral: Panel;
    panelETT: Panel;
    panelHeadOfHouseholdSpacer: Panel;
    panelHeadOfHouseholdTaxTable: Panel;
    panelMarriedTaxTable: Panel;
    panelSDI: Panel;
    panelSUI: Panel;
    panelSingleTaxTable: Panel;
    panelWithholdingGeneral: Panel;
    sourceHeadofhouseholdstatetaxtable: DataSource;
    sourceMarriedstatetaxtable: DataSource;
    sourceSinglestatetaxtable: DataSource;
    sourceStateTaxTable: DataSource;
    sourceStatetaxAdditional: DataSource;
    switchAllowanceType: Switch;
    tabAccounts: Tab;
    tabAdditionalTaxes: Tab;
    tabAutoTables: Tab;
    tabGeneral: Tab;
    tabWithholdingTables: Tab;
    tabsetMain: Tabset;
    textboxBonusTaxRate: Textbox;
    textboxDescription: Textbox;
    textboxEmployeeMaxSui: Textbox;
    textboxEmployerEttPct: Textbox;
    textboxEmployerId: Textbox;
    textboxEmployerMaxEtt: Textbox;
    textboxEmployerMaxSui: Textbox;
    textboxEmployerSdiAux: Textbox;
    textboxEmployerSui: Textbox;
    textboxEttExpGlid: Textbox;
    textboxEttLiabGlid: Textbox;
    textboxId: Textbox;
    textboxMagMediaCode: Textbox;
    textboxMaxAdjMarried: Textbox;
    textboxMaxAdjSingle: Textbox;
    textboxMaxEmployerSdi: Textbox;
    textboxMaxFicaWages: Textbox;
    textboxMaxSdi: Textbox;
    textboxPayeeSdiPct: Textbox;
    textboxPayeeSuiPct: Textbox;
    textboxSdiExpGlid: Textbox;
    textboxSdiLiabGlid: Textbox;
    textboxStdAdjPct: Textbox;
    textboxSuiExpGlid: Textbox;
    textboxSuiLiabGlid: Textbox;
    textboxTaxCalcMethod: Textbox;
    textboxTaxTableEmployerSdi: Textbox;
    textboxTaxTableEtt: Textbox;
    textboxTaxTableIncome: Textbox;
    textboxTaxTablePayeeSUI: Textbox;
    textboxTaxTableSdi: Textbox;
    textboxTaxTableUnemployment: Textbox;
    textboxTaxWhGlid: Textbox;
    textboxTypeOf: Textbox;
    textboxWhAllowAmt: Textbox;
}
